<template>
  <b-container>
    <h1>{{ $t("system.module.create") }}</h1>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />
    <b-row class="mb-3 ml-0">
      <router-link :to="getUrlBackToList">
        <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
      </router-link>
    </b-row>
    <b-row>
      <b-col sm="12" md="6" lg="6">
        <module-crud-data :model="model" :modelstate="modelstate">
        </module-crud-data>
      </b-col>
    </b-row>
    
    <b-row>
      <b-col>
        <b-button type="submit" :disabled="submitted" @click="save">
          {{ $t("geral.save") }}
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
export default {
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    ModuleCrudData: () =>
      import("@/components_rms/System/Module/ModuleCrudData.vue"),
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Registro criado com sucesso",
      },
      submitted: false,
      modelstate: {},
      model: {
        name: "",
        sequenceNumber: 0,
        inputImage: "",
        type: 0,
      },
      
    };
  },
  created() {
    this.newModel();
  },
  computed: {
    getUrlBackToList() {
      return `../module/all`;
    },
  },
  methods: {
    async newModel() {
      this.$apiScheduler
        .get("/module/GetLastSequenceNumber")
        .then((response) => {
          let model = response.data;
          this.model.sequenceNumber = model;
          this.model.name = " ";
        });
    },
    save() {
      console.log("ok");
      this.submitted = true;

      this.$apiScheduler
        .post("/module/create", this.model)
        .then((response) => {
          this.newModel();
          this.$refs.alert.show();
          this.modelstate = {};
          this.submitted = false;
        })
        .catch((error) => {
          this.submitted = false;
          this.modelstate = {};
          if (error.response) {
            console.log(error.response);
            if (error.response.status == 400) {
              console.log(error.response);
              console.log(error.response.data);
              console.log(error.response.data.errors);
              this.modelstate = error.response.data.errors;
              this.alert.error = "Verifique os dados informados";
            } else {
              if (error.response.data) {
                console.log(error.response.data);
                this.alert.error = `${error.response.status} - ${error.response.statusText} `;
              } else {
                this.alert.error = `${error.response.status} - ${error.response.statusText} `;
              }
            }
          } else {
            this.alert.error = error.message;
          }
          this.$refs.fadeAlertDanger.show();
        });
    },
  },
};
</script>
